import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button, Modal, Input, message, Tag } from 'antd';
import AdminLayout from '../../../components/admin/AdminLayout';
import {
  getAllSupportRequests,
  respondToSupportRequest,
  subscribeToSupportRequestChanges,
} from '../../../modules/supportRequestStorage';
import { clearSession } from '../../../modules/auth';
import './adminSupportRequests.css';

class AdminSupportRequests extends Component {
  state = {
    requests: getAllSupportRequests(),
    respondingId: null,
    responseMessage: '',
  };

  componentDidMount() {
    this.unsubscribe = subscribeToSupportRequestChanges((requests) => {
      this.setState({ requests });
    });
  }

  componentWillUnmount() {
    if (typeof this.unsubscribe === 'function') {
      this.unsubscribe();
    }
  }

  startResponding = (record) => {
    this.setState({
      respondingId: record.id,
      responseMessage: record.response || '',
    });
  };

  handleResponseChange = (event) => {
    this.setState({ responseMessage: event.target.value });
  };

  submitResponse = async () => {
    const { respondingId, responseMessage } = this.state;
    if (!respondingId) {
      return;
    }
    try {
      respondToSupportRequest(respondingId, responseMessage);
      message.success('Response saved.');
      this.setState({ respondingId: null, responseMessage: '' });
    } catch (error) {
      message.error(error.message || 'Unable to save the response.');
    }
  };

  render() {
    const { requests, respondingId, responseMessage } = this.state;
    const { admin, clearSession: logout } = this.props;
    const isViewer = admin && admin.user && admin.user.type === 'viewer';
    const columns = [
      {
        title: 'Submitted',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (value) => new Date(value).toLocaleString(),
      },
      {
        title: 'From',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <div>
            <strong>{record.name}</strong>
            <div className="admin-support__muted">{record.email}</div>
          </div>
        ),
      },
      {
        title: 'Subject',
        dataIndex: 'subject',
        key: 'subject',
      },
      {
        title: 'Message',
        dataIndex: 'message',
        key: 'message',
        render: (value) => <div className="admin-support__message">{value}</div>,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (value) => (
          <Tag color={value === 'responded' ? 'green' : 'blue'}>
            {value === 'responded' ? 'Responded' : 'Open'}
          </Tag>
        ),
      },
      ...(!isViewer ? [{
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          <Button size="small" onClick={() => this.startResponding(record)}>
            Respond
          </Button>
        ),
      }] : []),
    ];

    return (
      <AdminLayout
        title="Support Requests"
        subtitle="Track inbound help-center submissions."
        activeKey="support"
        admin={admin}
        onLogout={logout}
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={requests}
          pagination={{ pageSize: 8 }}
          locale={{ emptyText: 'No support requests yet.' }}
        />

        {!isViewer && <Modal
          title="Respond to request"
          open={Boolean(respondingId)}
          onCancel={() => this.setState({ respondingId: null, responseMessage: '' })}
          onOk={this.submitResponse}
          okText="Save response"
        >
          <Input.TextArea
            rows={4}
            value={responseMessage}
            onChange={this.handleResponseChange}
            placeholder="Write the reply that will be emailed to the user."
          />
        </Modal>}
      </AdminLayout>
    );
  }
}

AdminSupportRequests.propTypes = {
  admin: PropTypes.shape({
    user: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
  }),
  clearSession: PropTypes.func.isRequired,
};

AdminSupportRequests.defaultProps = {
  admin: null,
};

const mapStateToProps = (state) => ({
  admin: state.auth.admin,
});

const mapDispatchToProps = {
  clearSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminSupportRequests);
